import * as actions from './usuario.action';
import inicialState from './usuario.state';

const usuarioReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.PERMISSAO_USUARIO:
      return {
        ...state,
        role: action.payload.role,
      };
    case actions.ATUALIZAR_USUARIO:
      return {
        ...state,
        role: action.payload.role,
        usuario: action.payload.usuario,
        usuarioId: action.payload.usuarioId,
        medicoId: action.payload.medicoId,
        medico: action.payload.medico,
        isResidente: action.payload.isResidente,
      };

    default:
      return state;
  }
};

export default usuarioReducer;



// WEBPACK FOOTER //
// ./src/app/common/usuario/usuario.reducer.js